
const digest = '5665fc68afa157ffe264df220cee095d87dc3c69e6458fe8fe961a379ead18a7';
const css = `._pickerContainer_6p8t4_1 em-emoji-picker {
  width: 320px;
  height: 435px;

  --border-radius: 0;
  --shadow: none;
}

@media (max-width: 600px), (max-height: 600px) {
  ._pickerContainer_6p8t4_1 em-emoji-picker {
    width: 250px;
    height: 350px;
  }
}

._menuClass_6p8t4_16 {
  display: flex;
  align-items: center;
  gap: 5px;
  padding: 0px;
}
`;

(function() {
  if (!document.getElementById(digest)) {
    var el = document.createElement('style');
    el.id = digest;
    el.textContent = css;
    document.head.appendChild(el);
  }
})();
    
export default {"pickerContainer":"_pickerContainer_6p8t4_1","menuClass":"_menuClass_6p8t4_16"};
export { css, digest };
  